import { render, staticRenderFns } from "./ErrosTabelaSuporte.vue?vue&type=template&id=e58b1412"
import script from "./ErrosTabelaSuporte.vue?vue&type=script&lang=ts"
export * from "./ErrosTabelaSuporte.vue?vue&type=script&lang=ts"
import style0 from "./ErrosTabelaSuporte.vue?vue&type=style&index=0&id=e58b1412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports